import React, { useEffect } from "react";
import AdminSidebar from "./AdminSidebar";
import { LineChartElement, PieChartElement } from "./AdminCharts";
import { BsArrowUp
  // , BsArrowDown 
} from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { getDashboardStatsAction } from "../../redux/actions/adminAction";

const AdminDashboard = () => {
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const {
    usersCount,
    subscriptionsCount,
    viewsCount,
    // subscriptionPercentage,
    // viewPercentage,
    // userPercentage,
    // subscriptionProfit,
    // viewProfit,
    // userProfit,
    stats } = useSelector( state => state.admin)
  useEffect(() => {
    dispatch(getDashboardStatsAction());
  }, [dispatch]);

  
  return (
    <>
      <div className="grid grid-cols-5">
        <div className="">
          <AdminSidebar />
        </div>
        <div className="col-span-3">
          {" "}
          <div className="bg-white flex font-source cursor-default h-[800px] ">
            <div className="w-full h-full ">
              <div className="py-6 px-3">
                <h1 className="text-xl capitalize font-semibold">
                  Hello {user.name} !
                </h1>
                <h1>lets see how things are going on</h1>
              </div>
              <div className="sm:grid sm:grid-cols-2 lg:grid lg:grid-cols-3 gap-10 my-2 px-3">
                <div className="bg-[#DCDEF4] px-10 text-black font-semibold">
                  <h1>Views </h1>
                  <div className="flex">
                    <p>{viewsCount}</p>
                    {/* <p className="px-2 text-green-400">{viewPercentage} %</p> */}
                    <BsArrowUp className="text-green-400" />
                  </div>
                  <h1 className="font-light text-sm">Since Last Month</h1>
                </div>
                <div className="bg-[#F8EFE2] px-10 text-black font-semibold">
                  <h1>Users </h1>
                  <div className="flex">
                    <p>{usersCount}</p>
                    {/* <p className="px-2 text-green-400">{userPercentage} %</p> */}
                    <BsArrowUp className="text-green-400" />
                  </div>
                  <h1 className="font-light text-sm">Since Last Month</h1>
                </div>
                <div className="bg-[#EFF7E2] px-10 text-black font-semibold">
                  <h1>Subscriptions </h1>
                  <div className="flex">
                    <p>{subscriptionsCount}</p>
                    {/* <p className="px-2 text-red-400">{subscriptionPercentage} %</p> */}
                    <BsArrowUp className="text-green-400" />
                    
                  </div>
                  <h1 className="font-light text-sm">Since Last Month</h1>
                </div>
                <div className=" col-span-3">
                  View Line Graph
                  < LineChartElement  data={ stats && [stats[0]?.views , stats[1]?.views ,  stats[2]?.views , stats[3]?.views , stats[4]?.views , stats[5]?.views , stats[6]?.views , stats[7]?.views , stats[8]?.views , stats[9]?.views , stats[10]?.views , stats[11]?.views  ]  } />
                </div>
                {/* <div className=" border col-span-2 ">
                  <h1>bar graph</h1>

                  <div>
                    <p className="px-2">Views</p>{" "}
                    <div className="flex items-center">
                      {" "}
                      <div className={`bg-green-300 h-7 ${viewsCount ? bar1 : ''} my-2`}></div>{" "}
                      <p className="px-2">{viewsCount}</p>
                    </div>
                    <p className="px-2">Users</p>{" "}
                    <div className="flex items-center">
                      {" "}
                      <div className={`bg-green-300 h-7  my-2`}></div>{" "}
                      <p className="px-2">{usersCount}</p>
                    </div>
                    <p className="px-2">Subscriptions</p>{" "}
                    <div className="flex items-center">
                      {" "}
                      <div className={`bg-green-300 h-7 w-[${subscriptionsCount}%] my-2`}></div>{" "}
                      <p className="px-2">{subscriptionsCount}</p>
                    </div>
                  </div>
                </div> */}
                <div className=" ">
                  Pie Chart
                  <PieChartElement data={[subscriptionsCount, usersCount - subscriptionsCount]} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className=" bg-[#F6F6F6] text-center px-3 py-6 items-center text-[#141414] font-bold mx-2 text-base my-6">
            <h1 className="py-2">Profile</h1>
            <img
              alt="profile"
              className="h-[70px] rounded-full py-1 mx-auto"
              src={user?.avatar?.url}
            ></img>

            <div>
              <div>
                <h1 className="capitalize py-1 ">{user?.name}</h1>
                <h1 className="capitalize py-1">{user?.role} </h1>
              </div>

              <div>
                <h1 className="lowercase py-1">{user?.email} </h1>

                <h1 className="capitalize py-1 mb-4">
                  {user?.subscription?.status}{" "}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
